module.exports = "/dist/img/giftshopper_fabric5.427d62c4.jpg";